import { Observable } from "rxjs"
import ApiUrl from "./ApiUrl"
import ApiResponse from "./ApiResponse"
import { BuildFetchRequest } from "./BuildFetchRequest"
import { LogOut } from "../AppStore"

enum HttpStatusCode {
  UNAUTHORIZED = 401
}

export class APIError extends Error {
  errorData?: { code: string, message: string }
  constructor(message: string, errorData?: { code: string, message: string }) {
    super(message);
    this.name = "APIError"
    this.errorData = errorData
  }
}

export function ObservableFromFetch<T>(url: string, body?: string, method?: string): Observable<T> {
  return new Observable<T>(observer => {
    const controller = new AbortController()

    let init = BuildFetchRequest(body, method)
    init.signal = controller.signal

    fetch(ApiUrl() + url, init)
      .then((response: Response) => {
        if (response.ok) {
          return response.json()
        } else {
          return response.text()
            .then(data => data ? JSON.parse(data) : {})
            .then(json => {
              throw json.error
                ? new APIError(response.statusText, json.error)
                : response.status === HttpStatusCode.UNAUTHORIZED
                  ? new APIError(response.statusText, { code: response.status.toString(), message: response.statusText })
                  : new Error(response.statusText)
            })
        }
      })
      .then((result: ApiResponse<T>) => {
        observer.next(result.data)
        observer.complete()
      })
      .catch(err => {
        observer.error(err)
        if (err.errorData?.code === HttpStatusCode.UNAUTHORIZED.toString()) {
          LogOut()
        }
      })

    return () => {
      controller.abort()
    }
  })
}

// When async Task is missing in the code (RandomTest/RandomSelectionMessage)
export function ObservableFromFetchWithTaskData<T>(url: string, body?: string): Observable<T> {
  return new Observable<T>(observer => ObservableFromFetch<{ Result: T }>(url, body).subscribe(
    data => observer.next(data.Result),
    error => observer.error(error)
  ))
}
